export default __webpack_public_path__ + "021473e280d71d2b73442a8c2618a8ab.png";